'use client';

import { ChakraProvider, extendTheme } from '@chakra-ui/react';

import { GiftcardsErrorPage } from 'components';
import { baseTheme } from 'styles/theme';
import { ZmyleErrorId } from 'utils/constants';
import { formatDateAsZmyleApi } from 'utils/helpers';

const notFoundServerError: ZmyleError = {
  errorId: ZmyleErrorId.MALFORMED_URL,
  errorMsg: 'Not found',
  occurredAt: formatDateAsZmyleApi(new Date()),
  status: 404,
};

export function NotFoundErrorPage() {
  return (
    <ChakraProvider theme={extendTheme(baseTheme)}>
      <GiftcardsErrorPage error={notFoundServerError} />
    </ChakraProvider>
  );
}
